import './utilities/debugAnalytics';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {ApolloProvider} from '@apollo/client/react';
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom';

import App from './Components/App';
import store, {history} from './store/store';
import apolloClient from './store/apolloClient';
import {installPageViewTracker} from './utilities/pageViewTracker';
import {setAppHistory} from './helpers/historyManager';

setAppHistory(history);
installPageViewTracker();

const root = createRoot(document.getElementById('root'));

root.render(
  <ApolloProvider client={apolloClient}>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <App />
      </HistoryRouter>
    </Provider>
  </ApolloProvider>,
);
